import React from "react";
import parse from "html-react-parser";
import PropTypes from "prop-types";
import "./articleTitle.scss";

const ArticleTitle = ({ title }) => {
  return (
    <h1 itemProp="headline" className="article-title">
      {parse(title || " ")}
    </h1>
  );
};

ArticleTitle.propTypes = {
  title: PropTypes.string,
};

export default ArticleTitle;
